import { Kyc } from '@/types/user'
import api from './config'

export interface CreateParams {
  kyc: {
    vehicle_type?: string
    vehicle_price?: string
    vehicle_registration_date?: string
    vehicle_purchase_date?: string
    first_name?: string
    last_name?: string
    address?: string
    business_certificate_number?: string
    insurance_status?: string
    first_year_started_at?: string | null
  }
}

interface CreateResponse {
  kyc: Kyc
}

const kycAPI = {
  create: async (data: CreateParams) => {
    const response = await api.post<CreateResponse>('/kyc', data)
    return response.data
  },
}

export default kycAPI